export default __webpack_public_path__ + "static/media/common-iv-audio@3x.20cd4b5b.png";